export default __webpack_public_path__ + "static/hero_image_c-8f3501e1a7002b9c837f295324454eb9.jpg";